var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutboundTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4C16.0333 4 13.1332 4.87973 10.6665 6.52796C8.19971 8.17618 6.27713 10.5189 5.14181 13.2597C4.0065 16.0006 3.70945 19.0166 4.28823 21.9263C4.86701 24.8361 6.29562 27.5088 8.3934 29.6066C10.4912 31.7044 13.1639 33.133 16.0736 33.7118C18.9834 34.2905 21.9994 33.9935 24.7403 32.8582C27.4811 31.7229 29.8238 29.8003 31.472 27.3335C33.1203 24.8668 34 21.9667 34 19C34 15.0217 32.4196 11.2064 29.6066 8.3934C26.7936 5.58035 22.9782 4 19 4Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2 10H11.8C10.81 10 10 10.81 10 11.8V28L13.6 24.4H26.2C27.19 24.4 28 23.59 28 22.6V11.8C28 10.81 27.19 10 26.2 10ZM26.2 22.6H12.853L11.8 23.653V11.8H26.2V22.6ZM14.5 16.3H16.3V18.1H14.5V16.3ZM21.7 16.3H23.5V18.1H21.7V16.3ZM18.1 16.3H19.9V18.1H18.1V16.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundTextIcon);
export default __webpack_public_path__ + "static/media/outbound_text_icon.a6c716dea92fcb9cefc105708fcd17b8.svg";
export { ForwardRef as ReactComponent };